<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '480px'}"
  [modal]="false" [closeOnEscape]="true" [showCloseIcon]="true" styleClass="custom-sidebar"
  (onHide)="onSidebarHidden($event)">
  <div class="d-flex flex-column h-100">
    @if (artistId) {
      <div class="flex-grow-1 overflow-auto">
        <!-- Artist Products Section -->
        <div class="d-flex justify-content-between my-2">
          <!-- Status Filter and Search -->
          <div class="">
            <p-dropdown [options]="statusFilterOptions" [showClear]="true" [placeholder]="'showMoreSidePanel.filterByStatus' | transloco"
              [(ngModel)]="filters.status" (onChange)="onStatusFilterChange($event)" appendTo="body">
            </p-dropdown>
          </div>
          <div class="">
            <input type="text" class="form-control"
              (input)="moreArtistProductsDt.filterGlobal($any($event.target).value, 'contains')"
              [placeholder]="'showMoreSidePanel.search' | transloco" />
            </div>
          </div>
          <p-table #moreArtistProductsDt [value]="artistProducts" dataKey="Id" [loading]="loadingArtistProducts"
            [globalFilterFields]="['Name', 'SeriesName']">
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'Name'">
                  {{ 'showMoreSidePanel.artworkName' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr (click)="showProductDetails($event, rowData)" class="cursor-pointer">
                <td>
                  <div>
                    <img [src]="rowData.ResizedImageUrl" width="20" height="20">
                    {{rowData.Name}}
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="1">
                  <div class="text-center">{{ 'showMoreSidePanel.noArtworkFound' | transloco }}</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      @if (!artistId) {
        <div class="flex-grow-1 overflow-auto">
          <!-- Gallery Products Section -->
          <div class="row my-2">
            <div class="col-7">
              <input type="text" class="form-control"
                (input)="moreGalleryProductsDt.filterGlobal($any($event.target).value, 'contains')"
                [placeholder]="'showMoreSidePanel.searchGalleryProducts' | transloco" />
              </div>
            </div>
            <p-table #moreGalleryProductsDt [value]="galleryProducts" dataKey="Id" [loading]="loadingGalleryProducts"
              [globalFilterFields]="['Name']">
              <ng-template pTemplate="header">
                <tr>
                  <th [pSortableColumn]="'Name'">
                    {{ 'showMoreSidePanel.galleryProducts' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr (click)="showGalleryProductDetails($event, rowData)" class="cursor-pointer">
                  <td>
                    <div>
                      <img [src]="rowData.ProductImgUrl" width="20" height="20">
                      {{rowData.Name}}
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="1">
                    <div class="text-center">{{ 'showMoreSidePanel.noArtworkFound' | transloco }}</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </p-sidebar>
